<template lang="html">
  <v-container>
    <v-row>
      <setup-training-exams-dialog-create
        :course-id="courseId"
        @created="loadExams"
      />
    </v-row>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="exams"
      hide-default-footer
      fixed-header
      disable-pagination
      class="datatable-scrollbar"
    >
      <template v-slot:item.name="{ item }">
        <span>
          {{ item.name }}
        </span>
      </template>
      <template v-slot:item.passing_score="{ item }">
        <span>
          {{ item.passing_score }}
        </span>
      </template>
      <template v-slot:item.duration="{ item }">
        <span>
          {{ item.duration }}
        </span>
      </template>
      <template v-slot:item.max_attempt="{ item }">
        <span>
          {{ item.max_attempt }}
        </span>
      </template>

      <template v-slot:item.start_date="{ item }">
        <span>
          {{ $moment(item.start_date,'YYYY-MM-DD HH:mm::ss').format('YYYY-MM-DD hh:mm A') }}
        </span>
      </template>
      
      <template v-slot:item.end_date="{ item }">
        <span>
          {{ $moment(item.end_date,'YYYY-MM-DD HH:mm::ss').format('YYYY-MM-DD hh:mm A') }}
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <setup-training-exams-dialog-edit
          v-if="$hasPermissionTo(['update exams'])"
          :exam="item"
          @updated="loadExams"
        />
        <setup-training-exams-dialog-delete
          v-if="$hasPermissionTo(['delete exams'])"
          :exam="item"
          @deleted="loadExams"
        />
        <setup-training-exams-dialog-add-question 
          :exam="item"
          :open="openAddQuestionDialog (item)"
        />
        <setup-training-exams-dialog-view
          :exam="item"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupTrainingExamsDialogCreate: () => import('@/components/setup/training/exams/DialogCreate'),
      SetupTrainingExamsDialogEdit: () => import('@/components/setup/training/exams/DialogEdit'),
      SetupTrainingExamsDialogDelete: () => import('@/components/setup/training/exams/DialogDelete'),
      SetupTrainingExamsDialogAddQuestion: () => import('@/components/setup/training/exams/DialogAddQuestion'),
      SetupTrainingExamsDialogView: () => import('@/components/setup/training/exams/DialogView'),
    },
    props: {
      courseId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        loading: false,
        headers: [
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Passing Score(%)', value: 'passing_score', align: 'center' },
          { text: 'Duration(Minutes)', value: 'duration', align: 'center' },
          { text: 'Max Attempts', value: 'max_attempt', align: 'center' },
          { text: 'Exam Start Date', value: 'start_date', align: 'center' },
          { text: 'Exam End Date', value: 'end_date', align: 'center' },
          { text: '', sortable: false, value: 'action', align: 'center' },
        ],
        exams: [],
      }
    },  

    created () {
      this.loadExams()
    },

    methods: {
      loadExams () {
        this.loading = true
        this.$api.exams().list(this.courseId)
          .then(res => {
            this.exams = _.orderBy(res.data, ['start_date'], ['desc'])
            this.loading = false
          })
      },

      openAddQuestionDialog (item) {
        if (item.exam_questions.length > 0) {
          return false
        }
        return true
      },
    },
  }
</script>

<style scoped>
.datatable-scrollbar{
  height: 435px;
  overflow-y: auto;
}

.datatable-scrollbar::-webkit-scrollbar {
  width: 3px !important; 
}

/* Track */
.datatable-scrollbar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
.datatable-scrollbar::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
.datatable-scrollbar::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
</style>
